var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"p2p-market-sell-detail"}},[_c('p2p-form',{attrs:{"type":"SELL","currencyObj":_vm.currencyObj,"formId":_vm.$route.params.id || null}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }